import DiceBox from '@3d-dice/dice-box';

let diceBoxInstance = null;
let diceBoxInitialization = null;

export const getDiceBox = () => {
  if (!diceBoxInitialization) {
    diceBoxInstance = new DiceBox('#dice-box', {
      id: 'dice-canvas',
      assetPath: '/assets/dice-box/',
      startingHeight: 10,
      throwForce: 6,
      spinForce: 5,
      lightIntensity: 0.9,
      scale: 4,
      themeColor: '#e94f37',
    });
    diceBoxInitialization = diceBoxInstance.init().then(() => diceBoxInstance);
  }

  return diceBoxInitialization;
};